document.addEventListener('DOMContentLoaded', function() {
  
  // 1. GESTIONE QUANTITÀ E BOTTONE AGGIUNGI AL CARRELLO
  const qtyWrapper = document.querySelector('.koji-sp-qty');
  if (qtyWrapper) {
    const btnMinus = qtyWrapper.querySelector('.minus');
    const btnPlus = qtyWrapper.querySelector('.plus');
    const inputQty = qtyWrapper.querySelector('.koji-sp-qty-input');

    btnMinus.addEventListener('click', () => {
      let currentVal = parseInt(inputQty.value);
      if (currentVal > 1) {
        inputQty.value = currentVal - 1;
      }
    });

    btnPlus.addEventListener('click', () => {
      let currentVal = parseInt(inputQty.value);
      inputQty.value = currentVal + 1;
    });
  }

  const addBtn = document.querySelector('.koji-sp-add-btn');
  const form = document.getElementById('koji-sp-form');

  if (addBtn && form && !addBtn.disabled) {
    form.addEventListener('submit', function() {
      const loadingText = addBtn.getAttribute('data-loading-text') || 'SCANSIONE...';
      addBtn.querySelector('.koji-sp-add-text').innerText = loadingText;
      addBtn.style.pointerEvents = 'none';
      addBtn.style.opacity = '0.8';
    });
  }

  // ==============================================================
  // 2. GESTIONE BOTTONE PREFERITI (Sincronizzato al 100% con la tua pagina)
  // ==============================================================
  const WISHLIST_KEY = 'koji_wishlist_data'; // Chiave ufficiale corretta
  const wishlistBtn = document.querySelector('.koji-sp-wishlist-btn');
  
  function updateWishlistBadges(count) {
    document.querySelectorAll('.koji-wishlist-badge, .koji-cart-badge.koji-wishlist-badge').forEach(badge => {
      badge.textContent = count;
      if (count > 0) {
        badge.classList.add('is-active');
        badge.style.opacity = '1';
        badge.style.transform = 'scale(1)';
      } else {
        badge.classList.remove('is-active');
        badge.style.opacity = '0';
        badge.style.transform = 'scale(0.5)';
      }
    });
  }

  if (wishlistBtn) {
    // Estrapola tutti i dati salvati dal Liquid
    const handle = wishlistBtn.getAttribute('data-product-handle');
    const title = wishlistBtn.getAttribute('data-product-title');
    const price = wishlistBtn.getAttribute('data-product-price');
    const image = wishlistBtn.getAttribute('data-product-image');
    
    let currentWishlist = [];
    try {
      currentWishlist = JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
    } catch(e) {
      currentWishlist = [];
    }
    
    // Controlla se il prodotto c'è già in base all'handle
    const isSaved = currentWishlist.some(item => item.handle === handle);
    if (isSaved) {
      wishlistBtn.classList.add('is-active');
    }
    
    updateWishlistBadges(currentWishlist.length);

    wishlistBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      let wishlist = [];
      try {
        wishlist = JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
      } catch(e) {
        wishlist = [];
      }
      
      const index = wishlist.findIndex(item => item.handle === handle);
      
      if (index > -1) {
        // C'è già: rimuovilo dall'array
        wishlist.splice(index, 1);
        this.classList.remove('is-active');
      } else {
        // Non c'è: aggiungilo con TUTTI I DATI NECESSARI per la pagina preferiti
        wishlist.push({ handle, title, price, image });
        this.classList.add('is-active');
        if (navigator.vibrate) navigator.vibrate([20, 50, 20]);
      }
      
      // Salva nel browser
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(wishlist));
      updateWishlistBadges(wishlist.length);
    });
  } else {
    try {
      const wishlist = JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
      updateWishlistBadges(wishlist.length);
    } catch(e) {}
  }


  // 3. GESTIONE POP-UP "COVER ARTISTA" INTERATTIVO E ACCESSIBILE
  const artistBadgeWrap = document.querySelector('.koji-sp-artist-badge-wrapper');
  
  if (artistBadgeWrap) {
    const trigger = artistBadgeWrap.querySelector('.koji-artist-trigger');
    const tooltip = artistBadgeWrap.querySelector('.koji-artist-popup');
    const closeBtn = artistBadgeWrap.querySelector('.koji-artist-popup-close');
    let hasInteracted = false;
    let autoOpenTimeout;

    const openTooltip = () => {
      tooltip.classList.add('is-active');
      trigger.setAttribute('aria-expanded', 'true');
      tooltip.setAttribute('aria-hidden', 'false');
    };
    
    const closeTooltip = () => {
      tooltip.classList.remove('is-active');
      trigger.setAttribute('aria-expanded', 'false');
      tooltip.setAttribute('aria-hidden', 'true');
    };

    trigger.addEventListener('mouseenter', () => {
      if (window.innerWidth >= 990) {
        hasInteracted = true;
        openTooltip();
      }
    });

    artistBadgeWrap.addEventListener('mouseleave', () => {
      if (window.innerWidth >= 990) {
        closeTooltip();
      }
    });

    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      hasInteracted = true;
      if (tooltip.classList.contains('is-active')) {
        closeTooltip();
      } else {
        openTooltip();
      }
    });

    closeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      hasInteracted = true;
      closeTooltip();
      trigger.focus(); 
    });

    document.addEventListener('click', (e) => {
      if (!artistBadgeWrap.contains(e.target)) {
        closeTooltip();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && tooltip.classList.contains('is-active')) {
        closeTooltip();
        trigger.focus();
      }
    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !hasInteracted) {
          autoOpenTimeout = setTimeout(() => {
            if (!hasInteracted) {
              openTooltip();
              setTimeout(() => {
                if (!artistBadgeWrap.matches(':hover')) {
                  closeTooltip();
                }
              }, 6000);
            }
          }, 3000); 
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 }); 

    observer.observe(artistBadgeWrap);
  }

});